export const IC_GUIDELINES_TABLE_IDS = [
    'summary.headline',
    'summary.cross_holdings',
    'summary.ccy_exposures',
    'summary.mtm',
    'income.ucits',
    'beta.top_level',
    'diversifiers.strategic',
    'diversifiers.factor_weights',
    'diversifiers.gold_exposure',
    'protection.top_level',
    'protection.breakdown',
    'protection.cost_over_nav',
];
